var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next, jumper","page-size":_vm.limit,"total":_vm.data.total},on:{"current-change":_vm.handleCurrentChange},model:{value:(_vm.limit),callback:function ($$v) {_vm.limit=$$v},expression:"limit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }